// extracted by extract-css-chunks-webpack-plugin
module.exports = {"grid":"app-components-profile-socialsform--grid app-components-profile-profileform--grid"};